import { decodeContent } from '../../../utils'

export const apiUpdatePolygon = (map, options, mapID) => {
  // eslint-disable-next-line
  const self = REINOS_MAPS

  let polygon = self.searchPolygon(mapID, options.key)

  if (map && polygon !== undefined) {
    //remove key
    delete options.key

    //set the new user options
    polygon.setUserOptions(options)

    //update tooltip
    if (options.tooltip !== undefined) {
      //set the tooltip
      self.updateTooltip(options.tooltip, polygon)
      delete options.tooltip
    }

    //if latlngs is found in the options, use that for redraw the line
    if (typeof options.latlngs !== 'undefined') {
      polygon.setLatLngs(options.latlngs)
      delete options.latlngs
    }

    //set the new options
    polygon.setStyle(options)

    //set the popup content
    if (options.popup !== undefined && options.popup.popupContent !== undefined) {

      if (polygon.getPopup() === undefined) {
        //init the popup
        polygon = self.initPopup(polygon, options.popup)
      }
      else {
        const decodedContent = decodeContent(options.popup.popupContent)
        polygon.getPopup().setContent(decodedContent)
      }

      delete options.popup.popupContent
    }

    return polygon
  }
}
